import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Camera, Trash } from "@phosphor-icons/react";

// Kontaktfoto (z. B. Ansprechpartner in der Vermarktung)
export function ContactPhoto({ contact }) {
  const [url, setUrl] = useState(null);
  const [has, setHas] = useState(!!contact.photo_path);
  useEffect(() => {
    let u = null;
    if (!has) { setUrl(null); return undefined; }
    api.get(`/contacts/${contact.id}/photo`, { responseType: "blob" }).then(({ data }) => { u = URL.createObjectURL(data); setUrl(u); }).catch(() => setUrl(null));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [contact.id, has]);
  const upload = async (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/contacts/${contact.id}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } }); setHas(false); setTimeout(() => setHas(true), 0); toast.success("Foto gespeichert"); }
    catch (er) { toast.error(er?.response?.data?.detail || "Upload fehlgeschlagen"); }
  };
  const remove = async () => { await api.delete(`/contacts/${contact.id}/photo`); setHas(false); toast.success("Foto entfernt"); };
  return (
    <div className="relative group shrink-0" data-testid="contact-photo">
      <label className="h-14 w-14 rounded-full bg-slate-100 border border-slate-200 overflow-hidden flex items-center justify-center cursor-pointer" title="Foto hochladen">
        {url ? <img src={url} alt="" className="h-full w-full object-cover" data-testid="contact-photo-img" /> : <Camera size={18} className="text-slate-400" />}
        <input type="file" accept="image/*" className="hidden" onChange={upload} data-testid="contact-photo-input" />
      </label>
      {url && <button type="button" onClick={remove} className="absolute -bottom-1 -right-1 h-5 w-5 rounded-full bg-white border text-rose-600 hidden group-hover:flex items-center justify-center" data-testid="contact-photo-remove"><Trash size={10} /></button>}
    </div>
  );
}
